import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/login',
      component: () => import('@/pages/login')
    },

    {
      path: '/admin',
      component: () => import('@/pages/index'),
      hidden: true,
      children: [{
          path: '/couponsReceive',
          component: () => import('@/pages/couponsReceive')
        },
        {
          path: '/declareReceive',
          component: () => import('@/pages/declareReceive')
        },
        {
          path: '/giftManage',
          component: () => import('@/pages/giftManage')
        },
        {
          path: '/receipt',
          component: () => import('@/pages/receipt')
        },
        {
          path: '/productManage',
          component: () => import('@/pages/productManage')
        },

      ]
    },

    {
      path: '/',
      redirect: '/couponsReceive',
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js